import { get } from 'lodash'
const getStepsByStepNumber = function (state, currentRoute, stepNumber) {
  const stepsByStepNumber = state.stepsInformation.filter(
    (stepInformation) => {
       return (stepNumber === stepInformation.stepNumber)
    }
  )
  if (stepsByStepNumber.length > 1) {
    const stepByRoute = stepsByStepNumber.find(
      (stepInformation) => currentRoute === stepInformation.route
    )
    return stepByRoute
  }
  return stepsByStepNumber[0]
}

const stepperStore = {
  state: {
    showStepper: false,
    currentStep: null,
    previousStep: null,
    urlsWhereStepperShows: [],
    stepsInformation: [],
  },
  getters: {
    getTotalSteps: function ({stepsInformation}) {
      const highestStepNumber = stepsInformation.reduce((maxStep, step) => {
        return step.stepNumber > maxStep ? step.stepNumber : maxStep
      }, 0)
      return highestStepNumber
    },
    getStepsInformation: (state) => state.stepsInformation,
    getCurrentStepInformation: (state) => state.currentStep,
    getUrlsWhereStepperShows: (state) => state.urlsWhereStepperShows,
    getShowStepper: (state) => state.showStepper,
    getPreviousStep: (state) => state.previousStep
  },
  mutations: {
    setCurrentStep(state, currentStep) {
      state.currentStep = currentStep
    },
    showStepper(state) {
      state.showStepper = true
    },
    hideStepper(state) {
      state.showStepper = false
    },
    setStepsInformation (state, stepsInformation) {
      state.stepsInformation = stepsInformation
    },
    setUrlsWhereStepperShows (state, urls) {
      state.urlsWhereStepperShows = urls
    },
    setPreviousStep (state, previousStep) {
      state.previousStep = previousStep
    }
  },
  actions: {
    nextStep({ state, commit }, currentRoute) {
      const nextStepNumber = get(state, 'currentStep.stepNumber', 1)  + 1
      const nextStep = getStepsByStepNumber(state, currentRoute, nextStepNumber)
      commit("setPreviousStep", state.currentStep)
      commit("setCurrentStep", nextStep)
    },
    previousStep({ state, commit }, currentRoute) {
      const previousStepNumber = get(state, 'currentStep.stepNumber', 1) - 1
      const previousStep = getStepsByStepNumber(state, currentRoute, previousStepNumber)
      commit("setPreviousStep", state.currentStep)
      commit("setCurrentStep", previousStep)
    },
    showStepper({ commit }) {
      commit("showStepper")
    },
    hideStepper({ commit }) {
      commit("hideStepper")
    },
    initializeStepper ({ state, commit }, stepper) {
      const {stepsInformation, urlsWhereStepperShows, currentRoute} = stepper
      commit('setUrlsWhereStepperShows', urlsWhereStepperShows)
      commit('setStepsInformation', stepsInformation)
      const actualStep = getStepsByStepNumber(state, currentRoute, 1)
      commit("setCurrentStep", actualStep)
      commit("showStepper")
    },
    resetStepperInformation ({ commit }) {
      commit("hideStepper")
      commit("setTotalSteps", null)
      commit("setCurrentStep", null)
      commit("setPreviousStep", null)
      commit("setStepsInformation", [])
      commit("setUrlsWhereStepperShows", [])
    }
  },
}

export { stepperStore }